/* Custom JS — Mobi-mat Refonte */

/* Highlight the correct top-level menu item based on current URL */
(function () {
  var path = window.location.pathname;
  var topLinks = document.querySelectorAll('.menu-list__list-item > .menu-list__link');

  topLinks.forEach(function (link) {
    var rawHref = link.getAttribute('href');

    /* '#' links (Resources) — only check children */
    if (!rawHref || rawHref === '#') {
      var submenuId = link.getAttribute('aria-controls');
      if (submenuId) {
        var submenu = document.getElementById(submenuId);
        if (submenu) {
          var childAnchors = submenu.querySelectorAll('a[href]');
          for (var i = 0; i < childAnchors.length; i++) {
            try {
              var childPath = new URL(childAnchors[i].href, window.location.origin).pathname;
              if (childPath === path) {
                link.classList.add('menu-list__link--js-active');
                return;
              }
            } catch (e) {}
          }
        }
      }
      return;
    }

    var linkPath;
    try {
      linkPath = new URL(rawHref, window.location.origin).pathname;
    } catch (e) {
      return;
    }

    /* Home — exact match only */
    if (linkPath === '/') {
      if (path === '/') link.classList.add('menu-list__link--js-active');
      return;
    }

    /* Other links — current path starts with link path */
    if (path.indexOf(linkPath) === 0) {
      link.classList.add('menu-list__link--js-active');
    }
  });
})();

/* Fix: force menu style re-evaluation on resize (Horizon's isTouchDevice can stick to drawer) */
(function () {
  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var header = document.querySelector('#header-component');
      if (!header) return;
      var overflowList = header.querySelector('overflow-list');
      var hasMinReached = overflowList && overflowList.hasAttribute('minimum-reached');
      /* Only switch back to 'menu' if we have enough room (minimum NOT reached) */
      if (!hasMinReached && window.innerWidth >= 990) {
        header.dataset.menuStyle = 'menu';
      }
    }, 200);
  });
})();

/* ===== Contact form: pre-fill from "Get a Quote" link ===== */
(function () {
  var params = new URLSearchParams(window.location.search);
  if (params.get('quote') !== 'true') return;

  var product = params.get('product') || '';
  var variant = params.get('variant') || '';
  var sku = params.get('sku') || '';

  /* Pre-select "Quote Request" in subject */
  var subject = document.getElementById('ContactForm-subject');
  if (subject) subject.value = 'Quote Request';

  var body = document.getElementById('ContactForm-body');
  if (!body) return;

  var lines = ['Quote Request', ''];
  if (product) lines.push('Product: ' + product);
  if (variant) lines.push('Variant: ' + variant);
  if (sku) lines.push('SKU: ' + sku);
  lines.push('');
  lines.push('Quantity needed: [enter quantity]');
  lines.push('Delivery address for shipping estimate: [enter your address]');
  lines.push('');
  lines.push('I would like to receive a quote including pricing and shipping costs. Please contact me with a full estimate.');

  body.value = lines.join('\n');
})();

/* ===== Counter animation for stats (About page) ===== */
(function () {
  /* Only run on pages that have the stats grid */
  var statsGrid = document.querySelector('.rte div[style*="grid-template-columns"]');
  if (!statsGrid || !statsGrid.textContent.match(/30\+/)) return;

  var items = statsGrid.querySelectorAll('div');
  var counters = [];

  items.forEach(function (item) {
    var numEl = item.querySelector('p');
    if (!numEl) return;
    var text = numEl.textContent.trim();
    var match = text.match(/^(\d+)(.*)$/);
    if (match) {
      counters.push({ el: numEl, target: parseInt(match[1]), suffix: match[2] });
      numEl.textContent = '0' + match[2];
    }
  });

  if (counters.length === 0) return;

  function animateCounters() {
    var duration = 1500;
    var start = performance.now();

    function step(now) {
      var progress = Math.min((now - start) / duration, 1);
      /* Ease-out curve for a natural feel */
      var eased = 1 - Math.pow(1 - progress, 3);

      counters.forEach(function (c) {
        var current = Math.round(c.target * eased);
        c.el.textContent = current + c.suffix;
      });

      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  /* Trigger when the stats grid scrolls into view */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        animateCounters();
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    observer.observe(statsGrid);
  } else {
    animateCounters();
  }
})();
